<mat-sidenav-container fullscreen>
	<mat-menu #menu="matMenu">
		<mat-nav-list>
			<button mat-menu-item routerLink="/home" routerLinkActive="active-route">
				<mat-icon mat-list-icon>home</mat-icon>
				<span matLine>Inicial</span>
			</button>
			<mat-divider></mat-divider>
			<!-- <button mat-menu-item routerLink="/cotacoes" routerLinkActive="active-route" *ngIf="clienteLogado.fornecedor"> -->
			<button mat-menu-item routerLink="/lista-cotacoes" routerLinkActive="active-route">
				<mat-icon mat-list-icon>assignment</mat-icon>
				<span matLine>Cotações</span>
			</button>	
			<mat-divider></mat-divider>		
			<button mat-menu-item (click)="logout()">
				<mat-icon mat-list-icon>exit_to_app</mat-icon>
				<span matLine>Logout</span>
			</button>
		</mat-nav-list>
	</mat-menu>
	<mat-toolbar color="primary">
		<button mat-icon-button style="margin-right: 25px;" [matMenuTriggerFor]="menu">
			<mat-icon>menu</mat-icon>
		</button>
		<span class="app-fill-remaining-space"></span>
		<img id="clienteImage" src="assets/images/sua_logo.png" class="logo-filial" alt="Avatar" />
		<img src="assets/images/favicon.png" class="logo-filial" alt="Avatar" />
	</mat-toolbar>

<div>
	<mat-toolbar>
		<span>Cotações</span>
		<button mat-button (click)="load()">
			<mat-icon mat-list-icon>refresh</mat-icon>
		</button>
		<button *ngIf="!(cotacoes && cotacoes.length === 0)" mat-button routerLink="/cotacao-todos-itens">Cotações
			unificadas</button>
	</mat-toolbar>
	<h4 style="margin: 16px;" *ngIf="cotacoes && cotacoes.length === 0">Nenhuma solicitação cadastrada para este
		cliente.
	</h4>
	<mat-nav-list class="nav-list" *ngIf="cotacoes">
		<div *ngFor="let cotacao of cotacoes">
			<div class="item-espaco">
				<div class='custom-toolbar sombra'>
					<div [ngClass]="{'custom-toolbar-header': true}">
						<button mat-icon-button>
							<mat-icon [style.color]="getIconColor(cotacao)">{{getIcon(cotacao)}}</mat-icon>
						</button>
						<h4>Cotação {{cotacao.solicitacaoCompra.nrSolicitacao}}</h4>
					</div>
					<div [ngClass]="{'custom-toolbar-body': true}">
						<div>
							<div class="line">
								<mat-form-field class="cotacao-field">
									<mat-label>Data inicial</mat-label>
									<input matInput [(ngModel)]="cotacao.dtValidade" disabled />
								</mat-form-field>
								<mat-form-field class="cotacao-field">
									<mat-label>Prev. Entrega</mat-label>
									<input matInput [(ngModel)]="cotacao.diasPrevEntrega" placeholder="Prev. Entrega"
										name="prevEntrega" min="0" disabled>
									<span matSuffix>dias</span>
								</mat-form-field>
								<mat-form-field class="cotacao-field">
									<mat-label>Prazo de Pagamento</mat-label>
									<input matInput [(ngModel)]="cotacao.prazoPagamento"
										placeholder="Prazo de Pagamento" name="prazoPgto" maxlength="30" disabled>
								</mat-form-field>
								<mat-form-field class="cotacao-field">
									<mat-label>Tipo Frete</mat-label>
									<input matInput [(ngModel)]="cotacao.tpFrete" placeholder="Frete" name="vlFrete"
										disabled>
								</mat-form-field>
								<mat-form-field class="cotacao-field">
									<mat-label>Frete</mat-label>
									<input matInput [(ngModel)]="cotacao.vlFrete" placeholder="Frete" name="vlFrete"
										disabled>
									<span matPrefix>R$&nbsp;</span>
								</mat-form-field>
								<mat-form-field class="cotacao-field">
									<mat-label>Valor Total</mat-label>
									<input matInput [ngModel]="cotacao.vlTotal" placeholder="Valor Total" name="vlTotal"
										disabled>
									<span matPrefix>R$&nbsp;</span>
								</mat-form-field>
							</div>
							<div class="buttons">
								<div class="button">
									<button mat-raised-button color="primary"
										routerLink="/cotacao/{{cotacao.solicitacaoCompra.cdFilial}}/{{cotacao.solicitacaoCompra.nrSolicitacao}}">Editar</button>
								</div>
								<div class="button">
									<button mat-raised-button color="primary" (click)="getXls(cotacao)">
										<mat-icon class="mat-icon" color="white">cloud_download</mat-icon>
									</button>
								</div>
								<div class="button">
									<a>
										<input #myInputFile class="button-arquive" placeholder="input" value="value"
											accept=".xls" multiple="false" type="file"
											(change)="onFileChanged($event, cotacao.solicitacaoCompra.cdFilial, cotacao.solicitacaoCompra.nrSolicitacao)"
											hidden>
										<button mat-raised-button color="primary" (click)="myInputFile.click()">
											<mat-icon class="mat-icon" color="white">cloud_upload</mat-icon>
										</button>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="espaco-cabecalho"></div>
		</div>
	</mat-nav-list>
</div>
</mat-sidenav-container>